import { CSSProperties, FC } from 'react';

import logo from '../../../static_files/GMM-images/gmm-letters-white.svg';
import {
  useProcessedBannerStore,
  useProcessedWorkStore,
} from '../../../studentApp/hooks';
import { MOBILE_MARGIN, BOTTOM_BANNER_HEIGHT } from '../../constants';

import { GameCredits } from './gameCredits';
import { NameAndClass } from './nameAndClass';
import { PointsTodayAndWeek } from './pointsTodayAndWeek';

const bottomBannerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: BOTTOM_BANNER_HEIGHT + 'px',
  minHeight: BOTTOM_BANNER_HEIGHT + 'px',
  color: 'white',
  justifyContent: 'space-between',
};

export const BottomBanner: FC = () => {
  const {
    themeColor,
    themeColor2,
    showGamesMenu,
    showDisabledGamesMenu,
  } = useProcessedBannerStore();
  const { isTesting } = useProcessedWorkStore();

  return (
    <div
      style={{
        ...bottomBannerStyle,
        background: `linear-gradient(to right, ${themeColor2} 0%, ${themeColor} 50%, ${themeColor2} 100%)`,
        paddingLeft: '20px',
        paddingRight: '20px',
      }}
    >
      <NameAndClass />

      {!isTesting && (showGamesMenu || showDisabledGamesMenu) && (
        <GameCredits />
      )}

      <img src={logo} style={logoStyle} />
    </div>
  );
};

export const MobileBottomBanner: FC = () => {
  const { themeColor, themeColor2 } = useProcessedBannerStore();
  const { isTesting } = useProcessedWorkStore();

  return (
    <div
      style={{
        ...bottomBannerStyle,
        paddingLeft: MOBILE_MARGIN,
        paddingRight: MOBILE_MARGIN,
        background: `linear-gradient(to right, ${themeColor2} 0%, ${themeColor} 50%, ${themeColor2} 100%)`,
      }}
    >
      {!isTesting ? (
        <>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <PointsTodayAndWeek />
          </div>
          <img src={logo} style={{ ...logoStyle, height: '22px' }} />
        </>
      ) : (
        <>
          <NameAndClass />
          <img
            src={logo}
            style={{ ...logoStyle, marginLeft: 'auto', height: '22px' }}
          />
        </>
      )}
    </div>
  );
};

const logoStyle: CSSProperties = {
  display: 'flex',
  height: '29px',
  /* It's all about happy jbeye */
  transform: 'translateY(2px)',
};
